<template>
  <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.4 1.6a1.6 1.6 0 1 0 3.2 0 1.6 1.6 0 0 0-3.2 0zm0 6.4a1.6 1.6 0 1 0 3.2 0 1.6 1.6 0 0 0-3.2 0zm0 6.4a1.6 1.6 0 1 0 3.2 0 1.6 1.6 0 0 0-3.2 0z"
      fill="#A9B7D1"
      fill-rule="evenodd"
    />
  </svg>
</template>
